import Server from "../../backend/server";
import SocketMessage from "../../shared/socket/messages/socket-message";

/** A socket message utility for backend */
export default class SocketServer {
    /**
     * Constructs a socket utility instance
     * @param server the server instance
     */
    constructor(public server: Server) {}

    /** Sends a message */
    public message<T extends keyof SocketMessage.Types>(message: SocketMessage<T>) {
        global.executions.addLine({className: "SocketServer",functionName: "message",hierarchy: ["/backend/socket/socket-server.ts", "SocketServer", "message"],fileName: "/backend/socket/socket-server.ts",childLine: 14,line: "        this.server.websocket.emit('message', message)"});
        this.server.websocket.emit('message', message)
    }
}